const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export default isEqual;
